import React, { useContext } from "react";
import "./YourMheroDropDown.css";
import { Link } from "react-router-dom";
import img1 from "../../assets/images/mheroDropDown/link2.webp";
import img2 from "../../assets/images/mheroDropDown/link3.jpg";
import { LanguageContext } from "../../context/LanguageContext";

const YourMheroDropdown = ({ isOpen, onMouseEnter, onMouseLeave }) => {
  const { texts } = useContext(LanguageContext);

  return (
    <div
      className={`yourmhero-dropdown ${isOpen ? "open" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="yourmhero-left">
        <Link to="/order" className="link-item">
          {texts.navbar.buildYourMhero}
        </Link>
        <Link to="/testDrive" className="link-item">
          {texts.navbar.testDrive}
        </Link>
      </div>

      <div className="yourmhero-right">
        <Link to="/specification/MHERO1" className="spec-card">
          <img src={img1} alt="BEV" />
          <Link to="/specifications1" className="spec-link">
            {texts.navbar.specificationsMhero1}
          </Link>
        </Link>

        <Link to="/specification/MHERO2" className="spec-card">
          <img src={img2} alt="EREV" />
          <Link to="/specifications2" className="spec-link">
            {texts.navbar.specificationsMhero2}
          </Link>
        </Link>
      </div>
    </div>
  );
};

export default YourMheroDropdown;
